import { AntCol } from 'components/ant/AntCol';
import { AntRow } from 'components/ant/AntRow';
import { percent, valueOrNa } from 'components/utils/formatters';
import { IRank } from 'interfaces/graphql';
import React, { FC } from 'react';
import { routes } from 'routes';

import { ProgressBar } from './ProgressBar';
import s from './Rating.module.less';

interface Props {
  rank: IRank;
  providerId: number;
}

export const Rating: FC<Props> = ({ rank, providerId }) => {
  return (
    <a className="rating" href={`${routes.providerPath(providerId)}/rating_by_parts`} target="_blank" rel="noreferrer">
      <div className={s.wrapper}>
        <div className={s.title}>
          <div className={s.overallRatting}>
            <b>Overall Rating: </b>
            <b>⭐ {rank?.total || 'N/A'}</b>
          </div>
          <div>
            <span>Cancel Ratio: </span>
            <span>{rank?.cancelRatio ? percent((rank?.cancelRatio || 0) * 100) : 'N/A'}</span>
          </div>
        </div>
        <AntRow justify="space-between" align="bottom">
          <AntCol>
            <div>Timing</div>
            <div>Quality</div>
            <div>Packing</div>
            <div>Commun</div>
          </AntCol>
          <AntCol className={s.progressBarsWrapper}>
            <div>
              <ProgressBar value={rank?.timing || 0} />
            </div>
            <div>
              <ProgressBar value={rank?.quality || 0} />
            </div>
            <div>
              <ProgressBar value={rank?.packing || 0} />
            </div>
            <div>
              <ProgressBar value={rank?.communication || 0} />
            </div>
          </AntCol>
          <AntCol>
            <div>
              {valueOrNa(rank?.timing)}
              &nbsp;
              <span className={s.percent}>
                ({rank?.overdueRatio !== null ? percent((rank?.overdueRatio || 0) * 100) : 'N/A'})
              </span>
            </div>
            <div>
              {valueOrNa(rank?.quality)}
              &nbsp;
              <span className={s.percent}>
                ({rank?.qualityRatio !== null ? percent((rank?.qualityRatio || 0) * 100) : 'N/A'})
              </span>
            </div>
            <div>{valueOrNa(rank?.packing)}</div>
            <div>{valueOrNa(rank?.communication)}</div>
          </AntCol>
        </AntRow>
      </div>
    </a>
  );
};
